import { connect } from 'react-redux';

import { type State } from '../../../../state/types';
import {
	isConnectingSpace,
	isDisconnectedTemplatesClick,
} from '../../../../state/ui/connect-space/selectors';

import SpacePicker from './index';
import { getCloudId } from '../../../../state/context/selectors';
import { type StateProps, type AnalyticsProps } from './types';
import { getProjectId, getProjectType } from '../../../../state/project/selectors';

export default connect<StateProps, {}, AnalyticsProps, State>(
	(state: State) => ({
		isConnectingSpace: isConnectingSpace(state),
		isDisconnectedTemplatesClick: isDisconnectedTemplatesClick(state),
		cloudId: getCloudId(state),
		projectId: getProjectId(state),
		projectType: getProjectType(state),
	}),
	{},
)(SpacePicker);
